const colorToRGBCssString = (color) => {
  const obj = color.rgb().object();
  return `${obj.r}, ${obj.g}, ${obj.b}`;
};
const colorToHSLCssString = (color) => {
  const obj = color.hsl().object();
  return `${obj.h}, ${obj.s}%, ${obj.l}%`;
};

export { colorToHSLCssString, colorToRGBCssString };
//# sourceMappingURL=utils.js.map
